import type {
  Maintenance,
  MaintenanceVariable,
} from '../../context/MaintenanceProvider';
import type { PaymentMethodType } from '../../entities/enums';

export const getPaymentMethodsInMaintenance = (
  maintenanceDetail: MaintenanceVariable | undefined,
) => {
  if (!maintenanceDetail) {
    return undefined;
  }
  if (maintenanceDetail.paymentMethods.length > 0) {
    return maintenanceDetail.paymentMethods;
  }
  return undefined;
};

export const getMaintenanceByPaymentMethod = (
  paymentMethod: PaymentMethodType,
  paymentMethodInMaintenance?: Maintenance[],
): Maintenance | undefined => {
  const pm = paymentMethodInMaintenance;

  if (pm === undefined) {
    return undefined;
  }

  const singlePaymentMethodInMaintenance = pm.find(
    (p) => p.paymentMethod.toUpperCase() === paymentMethod.toUpperCase(),
  );

  return singlePaymentMethodInMaintenance;
};

export const getDisablePaymentByPaymentMethod = (
  paymentMethod: PaymentMethodType,
  hidePaymentMethod: boolean,
  paymentMethodInMaintenance?: Maintenance[],
): boolean => {
  if (hidePaymentMethod) {
    return true;
  }

  const pm = paymentMethodInMaintenance;

  if (pm === undefined) {
    return false;
  }

  const singlePaymentMethodInMaintenance = pm.find(
    (p) => p.paymentMethod.toUpperCase() === paymentMethod.toUpperCase(),
  );

  if (singlePaymentMethodInMaintenance === undefined) {
    return false;
  }

  return singlePaymentMethodInMaintenance.disablePayment ?? false;
};

export const getDisablePaymentMediumByPaymentMethod = (
  paymentMethodInMaintenance: Maintenance | undefined,
): string[] | undefined => {
  if (paymentMethodInMaintenance === undefined) return undefined;
  if (paymentMethodInMaintenance.paymentMedium === undefined) return undefined;
  return paymentMethodInMaintenance.paymentMedium
    .filter((item) => item.disablePayment === true)
    .map((item) => item.value);
};
